const providersOptions = [
  { id: 'battmobility', label: 'BattMobility' },
  // { id: 'bird', label: 'Bird' },
  { id: 'bluebike', label: 'Blue-bike' },
  { id: 'bolt', label: 'Bolt' },
  { id: 'cambio', label: 'Cambio' },
  // { id: 'cargoroo', label: 'Cargoroo' },
  { id: 'claus2you', label: 'Claus2You' },
  { id: 'coopstroom', label: 'CoopStroom' },
  { id: 'cozywheels', label: 'Cozywheels' },
  { id: 'degage', label: 'Dégage' },
  { id: 'donkey', label: 'Donkey Republic' },
  { id: 'dott', label: 'Dott' },
  // { id: 'getaround', label: 'GetAround' },
  // { id: 'hoppy', label: 'Hoppy' },
  { id: 'klimaan', label: 'Klimaan' },
  { id: 'libiavelo', label: 'Li Bia Velo' },
  { id: 'lime', label: 'Lime' },
  // { id: 'miles', label: 'Miles' },
  { id: 'mobilize', label: 'Mobilize Share' },
  { id: 'nextbike', label: 'nextbike' },
  // { id: 'pony', label: 'Pony' },
  { id: 'poppy', label: 'Poppy' },
  { id: 'stappin', label: 'Stapp In' },
  { id: 'veloantwerpen', label: 'Velo Antwerpen' },
  { id: 'villo', label: 'Villo!' },
  { id: 'voi', label: 'voi.' },
];

export {
  providersOptions,
};